import { FetchUserAccessFailed, FetchUserAccessResponse, FetchUserManagementListFailed, FetchUserManagementListResponse } from "../../types/streamAccessControl";
import { FETCHING_OWNER_STREAMS, FETCHING_OWNER_STREAMS_FAILED, FETCHING_OWNER_STREAMS_SUCCEEDED, FETCHING_STREAM_ACCESS_USERS, FETCHING_STREAM_ACCESS_USERS_FAILED, FETCHING_STREAM_ACCESS_USERS_SUCCEEDED, FETCHING_USER_ACCESS, FETCHING_USER_ACCESS_FAILED, FETCING_USER_ACCESS_SUCCEEDED, INVALIDATE_STREAM_ACCESS_USERS, SELECT_STREAM_FOR_ACCESS_MANAGEMENT, UPDATING_STREAM_ACCESS, UPDATING_STREAM_ACCESS_FAILED, UPDATING_STREAM_ACCESS_SUCCEDDED } from "../actions/actionTypes";
import _ from "lodash";


interface StreamAccessController {
  loading: boolean;
  invalidated: boolean;
  items: any[],
  stream: {
    id: string;
    name: string;
    readAll: boolean;
    writeAll: boolean;
    userAccess: {
      loading: boolean,
      invalidated: boolean,
      currentPage: number,
      totalPages: number,
      recordsPerPage: number,
      loadMore: boolean,
      items: any[],
      error: any
    },
    updatedUserAccess: boolean,
    updatedUserGroupAccess: any[],
    updatingUserAccess: boolean,
    error: any
  }
};

const initialState: StreamAccessController = {
  loading: false,
  invalidated: false,
  items: [],
  stream: {
    id: '',
    name: '',
    readAll: false,
    writeAll: false,
    userAccess: {
      loading: false,
      invalidated: false,
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 0,
      loadMore: false,
      items: [],
      error: ""
    },
    updatedUserAccess: false,
    updatedUserGroupAccess: [],
    updatingUserAccess: false,
    error: ""
  }
};

interface StreamAccessControllerActions {
  [key: string]: any;
}

export function streamAccessControllerReducer(state: StreamAccessController = initialState, action: StreamAccessControllerActions): StreamAccessController {
  switch (action.type) {
    case FETCHING_USER_ACCESS: {
      return {
        ...state,
        stream: {
          ...state.stream,
          userAccess: {
            ...state.stream.userAccess,
            loading: true,
            invalidated: false,
            loadMore: true
          },
          updatedUserAccess: false,
          updatedUserGroupAccess: []
        }
      }
    }

    case FETCING_USER_ACCESS_SUCCEEDED: {

      const data = action.payload as FetchUserAccessResponse;
      const loadMore = data.currentPage < data.totalPages - 1;

      return {
        ...state,
        stream: {
          ...state.stream,
          userAccess: {
            ...state.stream.userAccess,
            loading: false,
            invalidated: false,
            loadMore: loadMore,
            currentPage: data.currentPage + 1,
            totalPages: data.totalPages,
            recordsPerPage: data.recordsPerPage,
            items: data.currentPage === 0 ? data.records : [...state.stream.userAccess.items, ...data.records]
          }
        }
      }
    }

    case FETCHING_USER_ACCESS_FAILED: {

      const data = action.payload as FetchUserAccessFailed;
      const error = data.error;

      return {
        ...state,
        stream: {
          ...state.stream,
          userAccess: {
            ...state.stream.userAccess,
            loading: false,
            invalidated: false,
            loadMore: false,
            currentPage: state.stream.userAccess.currentPage,
            totalPages: state.stream.userAccess.totalPages,
            recordsPerPage: state.stream.userAccess.recordsPerPage,
            items: [],
            error: error
          }
        }
      }
    }

    case FETCHING_STREAM_ACCESS_USERS: {
      return {
        ...state,
        stream: {
          ...state.stream,
          userAccess: {
            ...state.stream.userAccess,
            loading: true,
            invalidated: false,
            loadMore: true
          },
          updatedUserAccess: false,
          updatedUserGroupAccess: []
        }
      }
    }

    case FETCHING_STREAM_ACCESS_USERS_SUCCEEDED: {
      const data = action.payload as FetchUserManagementListResponse
      const loadMore = data.currentPage < data.totalPages - 1;
      let items: any[] = [];

      if (data.currentPage == 0) {
        items = data.records;
      } else {
        items = [...state.stream.userAccess.items, ...data.records];
      }

      items = _.orderBy(
        items,
        [
          "entityType",
          (item) => {
            const entityType = _.get(item, "entityType");
            if (entityType === "user") {
              return item.user?.enabled === true ? 0 : 1;
            }
            return 0;
          },
          (item) => {
            const entityType = _.get(item, "entityType");
            let name = "";
            if (entityType === "user") {
              name = item.user?.name || "";
            } else {
              name = item.userGroup?.name || "";
            }
            return _.toLower(name);
          },
        ],
        ["desc", "asc", "asc"],
      );

      return {
        ...state,
        stream: {
          ...state.stream,
          userAccess: {
            ...state.stream.userAccess,
            loading: false,
            invalidated: false,
            loadMore: loadMore,
            items: items,
            currentPage: action.payload.currentPage + 1,
            totalPages: action.payload.totalPages,
            recordsPerPage: action.payload.recordsPerPage,
          },
          updatedUserAccess: false,
          updatedUserGroupAccess: []
        }
      }
    }

    case FETCHING_STREAM_ACCESS_USERS_FAILED: {
      const data = action.payload as FetchUserManagementListFailed;

      return {
        ...state,
        stream: {
          ...state.stream,
          userAccess: {
            ...state.stream.userAccess,
            error: data
          }
        }
      }
    }


    case UPDATING_STREAM_ACCESS: {
      return {
        ...state,
        stream: {
          ...state.stream,
          updatingUserAccess: true,
          updatedUserAccess: false
        }
      }
    }

    case UPDATING_STREAM_ACCESS_SUCCEDDED: {
      const data = action.payload.response;

      const updatedItems = state.stream.userAccess.items.map((item: any) => {
        if (item.entityType === "user") {
          const matchingUser = data.users.find((u: any) => u.user.id === item.user.id);
          return matchingUser || item;
        } else if (item.entityType === "user_group") {
          const matchingUserGroup = data.userGroups.find((ug: any) => ug.userGroup.id === item.userGroup.id);
          return matchingUserGroup || item;
        }
        return item;
      });

      const updatedStreamItems = state.items.map((stream: any) => {
        if (stream.id === state.stream.id) {
          return {
            ...stream,
            readAll: data.readAll,
            writeAll: data.writeAll
          }
        }
        return stream;
      })
      return {
        ...state,
        items: updatedStreamItems,
        stream: {
          ...state.stream,
          updatingUserAccess: false,
          updatedUserAccess: true,
          readAll: data.readAll,
          writeAll: data.writeAll,
          userAccess: {
            ...state.stream.userAccess,
            items: updatedItems
          }
        }
      }
    }

    case UPDATING_STREAM_ACCESS_FAILED: {
      return {
        ...state,
        stream: {
          ...state.stream,
          updatingUserAccess: false,
          updatedUserAccess: false,
          error: action.payload
        }
      }
    }

    case FETCHING_OWNER_STREAMS: {
      return {
        ...state,
        loading: true,
        invalidated: true
      }
    }

    case FETCHING_OWNER_STREAMS_SUCCEEDED: {
      console.log(action.payload);
      return {
        ...state,
        loading: false,
        invalidated: false,
        items: action.payload.sort((a, b) => {
          return a.name > b.name ? 1 : a.name < b.name ? -1 : 0;
        })
      }
    }

    case FETCHING_OWNER_STREAMS_FAILED:
      return {
        ...state,
        loading: false,
        invalidated: false
      }

    case SELECT_STREAM_FOR_ACCESS_MANAGEMENT: {
      return {
        ...state,
        stream: {
          ...action.payload,
          userAccess: {
            loading: false,
            invalidated: false,
            loadMore: true,
            currentPage: 0,
            totalPages: 0,
            recordsPerPage: 0,
            items: []
          },
          updatedUserAccess: false,
          updatedUserGroupAccess: []
        }
      }
    }

    case INVALIDATE_STREAM_ACCESS_USERS: {
      return {
        ...state,
        stream: {
          id: "",
          name: '',
          readAll: false,
          writeAll: false,
          userAccess: {
            loading: false,
            invalidated: true,
            currentPage: 0,
            totalPages: 0,
            recordsPerPage: 0,
            loadMore: true,
            items: [],
            error: ""
          },
          updatedUserAccess: false,
          updatedUserGroupAccess: [],
          updatingUserAccess: false,
          error: ""
        }
      }
    }

    default:
      return state;

  }
}